import React, { Component } from 'react'
import _ from 'lodash'
import { Message } from '@paypalcorp/worldready-react'

import { shareConstants } from '../constants/shareConstants'

import { fetchOrUpdateShareeDetails } from '../api/request'

import {
  copyAndCreateObject,
  isUserHasAccess,
  constructUserNameToDisplay,
  getLocalizedContent,
  isFile,
} from '../helper'
import { ReactComponent as FolderClose } from '../images/folder-line.svg'
import {
  validateCustomMessage,
  validateEmailId,
} from '../../../server/src/routes/validator'
import InputBox from './InputBox'
import TextBox from './TextBox'

class ShareNew extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      statusMsg: { msg: '', status: 'success', emailError: false },
      searchValue: '',
      shareWithUserMailId: '',
      shareWithUserList: {},
      invalidShareeList: {},
      currentShareeList: {},
      newShareeList: {},
      searchNewShareeUserList: {},
      searchCurrentShareeUserList: {},
      showPermission: false,
      showPermissionFor: '',
      changePermissionForUserOfType: '',
      permissionBoxPosition: [],
      appliedPermissionDefault: shareConstants.DefaultPermissions,
      finalShareeList: [],
      unshareUserList: [],
      shareInProgress: false,
      isFetchShareInfoInProgress: false,
      messageToShare: '',
      lastEnterKeyPressedTime: 0,
    }
    this.sharedItem = '{}'
    this.textInput = React.createRef()
    this.textArea = React.createRef()
    this.shareeListContainer = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('click', this.handleOutsideClick, false)
    this.checkShareInfo()
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false)
  }

  componentDidUpdate(prevState) {
    const { statusMsg } = this.props
    if (!_.isEqual(statusMsg, prevState.statusMsg) && !statusMsg.emailError) {
      this.updateErrorTimer()
    }
  }

  updateShareDetails = (isUnshare) => {
    const timer = setTimeout(() => {
      this.updateStateDefault()
      if (!isUnshare) {
        this.checkShareInfo()
      }
    }, 1000)
    return () => clearTimeout(timer)
  }

  updateStateDefault = () => {
    this.setState({
      shareInProgress: false,
      finalShareeList: [],
      unshareUserList: [],
      shareWithUserList: {},
      currentShareeList: {},
      newShareeList: {},
    })
    this.sharedItem = '{}'
  }

  updateErrorTimer = () => {
    const timer = setTimeout(() => {
      this.setState({ statusMsg: { msg: '', status: 'success' } })
    }, 500)
    return () => clearTimeout(timer)
  }

  updateState = (key, value) => {
    this.setState({ [key]: value })
  }

  checkShareInfo = () => {
    const { itemToShare } = this.props
    if (itemToShare.isShared) {
      this.getShareInfo(itemToShare)
    }
  }

  getShareInfo = async (itemToShare) => {
    this.updateStatusMsgAndRequestInProgressState(
      true,
      getLocalizedContent('share.fetch.info'),
      'attention',
    )
    const getShareeResponse = await fetchOrUpdateShareeDetails(
      'GET',
      itemToShare.path,
      {},
    )
    this.updateStatusMsgAndRequestInProgressState(false, '', 'success')
    if (getShareeResponse.status === 200) {
      const result = JSON.parse(getShareeResponse.text).results
      this.updateShareeDetails(result)
    } else {
      this.constructErrorMessage(getShareeResponse, itemToShare, 'share')
    }
  }

  updateStatusMsgAndRequestInProgressState = (
    isFetchShareInfoInProgress,
    msg,
    status,
  ) => {
    this.setState({
      isFetchShareInfoInProgress,
      statusMsg: { msg, status },
    })
  }

  updateShareeDetails = (result) => {
    let shared = {}
    if (result.length > 0) {
      result.forEach((item) => {
        shared[item.sharedWith] = item
      })
      if (!shareConstants.IsDifferentPermissionForShareeAllowed) {
        this.setDefaultPermission(result)
      }
    }
    this.props.actions.setSharedUserList(shared)
    this.sharedItem = JSON.stringify(shared)
    this.setState({
      currentShareeList: shared,
    })
  }

  setDefaultPermission = (result) => {
    this.setState({
      appliedPermissionDefault: {
        permission: result[0].permission,
        enableNotifications: result[0].enableNotifications,
        enableOwnerNotifications: result[0].enableOwnerNotifications,
        showCollaborators: result[0].showCollaborators,
        enableEmailMask: result[0].enableEmailMask,
      },
    })
  }

  constructErrorMessage = (error, itemToShare, operation) => {
    const statusMsg = this.props.constructErrorMessage(
      error,
      itemToShare,
      operation,
      false,
    )
    if (error.status === 401) {
      this.props.setShareBoxVisibility(false, {})
    }
    this.setState({ statusMsg })
  }

  setRef = (ref) => {
    this.permissionBoxRef = ref
  }

  searchUser = (evt) => {
    const value = evt.target.value
    const { currentShareeList, newShareeList } = this.state

    const searchNewSharee = Object.keys(newShareeList).filter((user) =>
      user.includes(value),
    )
    const searchCurrentSharee = Object.keys(currentShareeList).filter((user) =>
      user.includes(value),
    )

    this.setState({
      searchNewShareeUserList: copyAndCreateObject(
        newShareeList,
        searchNewSharee,
      ),
      searchCurrentShareeUserList: copyAndCreateObject(
        currentShareeList,
        searchCurrentSharee,
      ),
      searchValue: evt.target.value,
    })
  }

  handleOutsideClick = (event) => {
    if (
      this.permissionBoxRef &&
      !this.permissionBoxRef.contains(event.target)
    ) {
      if (!event.target.classList.value.includes('permission_ref')) {
        this.dismissPermisssion()
      }
    }
    return
  }

  dismissPermisssion = () => {
    this.setState({
      showPermission: false,
      showPermissionFor: '',
      permissionBoxPosition: [],
    })
  }

  unshareUser = (userId, type, isAFile = false) => {
    let {
      newShareeList,
      finalShareeList,
      unshareUserList,
      currentShareeList,
    } = this.state
    const sharedUserItem = JSON.parse(this.sharedItem)
    this.dismissPermisssion()
    if (type === 'new') {
      delete newShareeList[userId]
      this.removeErrorMessage()
    } else if (type === 'shared') {
      const isUserAlreadyAddedForUnshare = unshareUserList.includes(userId)
      if (isUserAlreadyAddedForUnshare) {
        unshareUserList = unshareUserList.filter((el) => el !== userId)
        if (!isAFile) {
          /* While Undo user from unsharing, restore the permissions of user  */
          currentShareeList[userId] = sharedUserItem[userId]
        }
      } else {
        unshareUserList.push(userId)
      }
    }
    finalShareeList = finalShareeList.filter((el) => el !== userId)
    this.setState({ newShareeList, finalShareeList, unshareUserList })
  }

  addNewSharee = () => {
    let {
      finalShareeList,
      shareWithUserList,
      changePermissionForUserOfType,
      currentShareeList,
      newShareeList,
    } = this.state
    if (this.isSharingAllowed()) {
      if (changePermissionForUserOfType === '') {
        finalShareeList = finalShareeList.concat(Object.keys(shareWithUserList))
        this.setState((prevState) => ({
          newShareeList: {
            ...prevState.shareWithUserList,
            ...prevState.newShareeList,
          },
          finalShareeList,
          showPermission: false,
          shareWithUserList: {},
        }))
        if (shareConstants.IsDifferentPermissionForShareeAllowed) {
          this.setState({
            appliedPermissionDefault: shareConstants.DefaultPermissions,
          })
        }
      } else {
        if (changePermissionForUserOfType === 'shared') {
          finalShareeList = finalShareeList.concat(
            Object.keys(currentShareeList),
          )
        } else if (changePermissionForUserOfType === 'new') {
          finalShareeList = finalShareeList.concat(Object.keys(newShareeList))
        }
        this.setState({
          finalShareeList,
          showPermission: false,
          shareWithUserList: {},
          changePermissionForUserOfType: '',
        })
        if (shareConstants.IsDifferentPermissionForShareeAllowed) {
          this.setState({
            appliedPermissionDefault: shareConstants.DefaultPermissions,
          })
        }
      }
    }
  }

  setNoPermissionChangeAllowedMessage = () => {
    this.setState({
      showPermission: false,
      statusMsg: {
        msg: getLocalizedContent(
          shareConstants.ShareWithDifferentPermissionAlert,
        ),
        status: 'error',
      },
    })
  }

  verifyPermission = (evt, type, value, shareeDetails) => {
    if (type === 'permission') {
      if (
        this.checkPermissionsSet(value) ===
        this.permissionForFileVault(shareeDetails.permission)
      ) {
        return true
      }
      this.setNoPermissionChangeAllowedMessage()
    } else if (type === 'notification') {
      if (shareeDetails[value] === evt.target.checked) {
        return true
      }
      this.setNoPermissionChangeAllowedMessage()
    }
    return false
  }

  isChangePermissionAllowed = (evt, type, value) => {
    const {
      newShareeList,
      currentShareeList,
      changePermissionForUserOfType,
    } = this.state

    if (
      changePermissionForUserOfType === '' &&
      !shareConstants.IsDifferentPermissionForShareeAllowed
    ) {
      const currentShareeUserList = Object.keys(currentShareeList)
      const newShareeUserList = Object.keys(newShareeList)

      if (
        newShareeUserList.length === 0 &&
        currentShareeUserList.length === 0
      ) {
        return true
      }
      if (currentShareeUserList.length > 0) {
        this.verifyPermission(
          evt,
          type,
          value,
          currentShareeList[currentShareeUserList[0]],
        )
      } else if (newShareeUserList.length > 0) {
        this.verifyPermission(
          evt,
          type,
          value,
          newShareeList[newShareeUserList[0]],
        )
      }
    }
    return shareConstants.IsDifferentPermissionForShareeAllowed
  }

  changePermissionForAddNewUser = (evt, type, value) => {
    let { shareWithUserList, appliedPermissionDefault } = this.state
    if (this.isChangePermissionAllowed(evt, type, value)) {
      Object.keys(shareWithUserList).forEach((userId) => {
        shareWithUserList = this.setPermission(
          evt,
          type,
          value,
          shareWithUserList,
          userId,
        )
      })
      appliedPermissionDefault = this.setPermission(
        evt,
        type,
        value,
        appliedPermissionDefault,
      )
      this.setState({ shareWithUserList, appliedPermissionDefault })
    }
  }

  setPermission = (evt, type, value, shareeList, userId = '') => {
    const sharee = Object.assign({}, shareeList)

    if (type === 'permission') {
      if (userId !== '') {
        sharee[userId].permission = this.checkPermissionsSet(value)
      } else {
        sharee.permission = this.checkPermissionsSet(value)
      }
    } else if (type === 'notification') {
      if (userId !== '') {
        sharee[userId][value] = evt.target.checked
      } else {
        sharee[value] = evt.target.checked
      }
    }
    return sharee
  }

  changePermissionForCurrentSharee = (evt, type, value, userId) => {
    let {
      appliedPermissionDefault,
      currentShareeList,
      finalShareeList,
      unshareUserList,
    } = this.state
    const existingShareeList = Object.assign({}, JSON.parse(this.sharedItem))

    currentShareeList = this.setPermission(
      evt,
      type,
      value,
      currentShareeList,
      userId,
    )

    if (userId !== '') {
      if (_.isEqual(existingShareeList[userId], currentShareeList[userId])) {
        finalShareeList = finalShareeList.filter((el) => el !== userId)
      } else if (!finalShareeList.includes(userId)) {
        finalShareeList.push(userId)
      }
    }
    unshareUserList = unshareUserList.filter((el) => el !== userId)
    this.setState({
      currentShareeList,
      finalShareeList,
      appliedPermissionDefault,
      unshareUserList,
    })
  }

  changePermissionForExistingUser = (evt, userId, type, value) => {
    const { changePermissionForUserOfType } = this.state
    if (changePermissionForUserOfType === 'shared') {
      this.changePermissionForCurrentSharee(evt, type, value, userId)
    } else {
      this.changePermissionForNewSharee(evt, type, value, userId)
    }
  }

  changePermissionForNewSharee = (evt, type, value, userId) => {
    let { newShareeList, appliedPermissionDefault } = this.state
    newShareeList = this.setPermission(evt, type, value, newShareeList, userId)
    this.setState({ newShareeList, appliedPermissionDefault })
  }

  changePermission = (evt, type, value, userId) => {
    const { changePermissionForUserOfType } = this.state
    if (userId === '' && changePermissionForUserOfType === '') {
      /*this executes while adding new user */
      this.changePermissionForAddNewUser(evt, type, value)
      return
    }
    if (shareConstants.IsDifferentPermissionForShareeAllowed) {
      /*this executes while changing permission for already added user */
      this.changePermissionForExistingUser(evt, userId, type, value)
    }
  }

  removeUser = (item) => {
    this.removeErrorMessage()
    this.setState((prevState) => ({
      shareWithUserList: Object.keys(prevState.shareWithUserList)
        .filter((key) => key !== item)
        .reduce((result, current) => {
          result[current] = prevState.shareWithUserList[current]
          return result
        }, {}),
      invalidShareeList: _.omit(prevState.invalidShareeList, item),
    }))
  }

  onChangeMailId = (evt) => {
    if (this.isSharingAllowed('new')) {
      this.setState({
        shareWithUserMailId: evt.target.value,
        statusMsg: {
          msg: '',
          status: 'success',
          emailError: false,
        },
      })
    }
  }

  setShareErrorMessage = (msg, status, emailError) => {
    this.setState({
      statusMsg: {
        msg,
        status,
        emailError,
      },
    })
  }

  checkForMailId = (newMailId, username, mailIdToCheck) => {
    return (
      newMailId.replace('@paypalcorp.com', '') === username ||
      newMailId.replace('@paypal.com', '') === username ||
      newMailId === mailIdToCheck
    )
  }

  isShareeAdhoc = (shareeId) => {
    return !(
      _.endsWith(shareeId, '@paypal.com') ||
      _.endsWith(shareeId, '@paypalcorp.com')
    )
  }

  hasAccessForSharingWithAdhocUser = (newMailId, user) => {
    return (
      this.isShareeAdhoc(newMailId) && !isUserHasAccess(user, 'Share').hasAccess
    )
  }

  isSharingAllowed = (type = '') => {
    const {
      shareWithUserList,
      newShareeList,
      currentShareeList,
      messageToShare,
      unshareUserList,
    } = this.state
    const { user } = this.props
    const totalNoOfNewSharee =
      Object.keys(shareWithUserList).length + Object.keys(newShareeList).length
    const totalNoOfSharee =
      Object.keys(shareWithUserList).length +
      Object.keys(newShareeList).length +
      Object.keys(currentShareeList).length
    if (
      totalNoOfNewSharee > shareConstants.TotalNoOfShareePerShare &&
      totalNoOfSharee < shareConstants.TotalNoOfShareeAllowed
    ) {
      this.setShareErrorMessage(
        <Message
          id="share.user.per.group.limit.alert"
          limit={shareConstants.TotalNoOfShareePerShare}
        />,
        'error',
        false,
      )
      return false
    }
    if (
      (totalNoOfSharee > shareConstants.TotalNoOfShareeAllowed &&
        type === '' &&
        Object.keys(unshareUserList).length <= 0) ||
      (type === 'new' &&
        totalNoOfSharee >= shareConstants.TotalNoOfShareeAllowed)
    ) {
      const combinedMessage = (
        <>
          <Message
            id="share.user.total.limit.alert"
            limit={shareConstants.TotalNoOfShareeAllowed}
          />
          <Message
            id="share.user.total.sharee.limit.alert"
            limit={totalNoOfSharee}
          />
        </>
      )

      this.setShareErrorMessage(combinedMessage, 'error', false)
      return false
    }
    if (messageToShare !== '' && !isUserHasAccess(user, 'Content').hasAccess) {
      this.setShareErrorMessage(
        getLocalizedContent(shareConstants.CustomMessageNotAllowedAlert),
        'error',
        false,
      )
      return false
    }
    return true
  }

  removeErrorMessage = () => {
    this.setShareErrorMessage('', 'success', false)
  }

  editEmailId = (id) => {
    this.setState((prevState) => ({
      shareWithUserMailId: id,
      shareWithUserList: _.omit(prevState.shareWithUserList, id),
      invalidShareeList: _.omit(prevState.invalidShareeList, id),
    }))
    this.textInput.current.focus()
  }

  updateInvalidMailIdDetails = (
    invalidMailIds,
    selfIdList,
    existingCorpMailIdList,
    existingAdhocMailIdList,
    adhocMailIdList,
  ) => {
    const { user, itemToShare, deployEnv } = this.props
    /* Check permission for sharing with external user */
    const { hasAccess, isCOC } = isUserHasAccess(user, 'Share')
    const isSharingWithAdhocUserAllowed = deployEnv.isProd && hasAccess
    let invalidShareeList = {}
    /* Add all email id's to error list with proper error message */
    invalidMailIds.map((id) => {
      invalidShareeList = {
        ...invalidShareeList,
        [id]: getLocalizedContent(shareConstants.InvalidEmailAlert),
      }
    })
    selfIdList.map((id) => {
      invalidShareeList = {
        ...invalidShareeList,
        [id]: getLocalizedContent(
          isFile(itemToShare.fileType)
            ? shareConstants.ShareFileToSelfAlert
            : shareConstants.ShareFolderToSelfAlert,
        ),
      }
    })
    existingCorpMailIdList.map((id) => {
      invalidShareeList = {
        ...invalidShareeList,
        [id]: getLocalizedContent(shareConstants.MailIdExistAlert),
      }
    })
    existingAdhocMailIdList.map((id) => {
      invalidShareeList = {
        ...invalidShareeList,
        [id]: getLocalizedContent(shareConstants.MailIdExistAlert),
      }
    })
    if (!isSharingWithAdhocUserAllowed) {
      adhocMailIdList.map((id) => {
        invalidShareeList = {
          ...invalidShareeList,
          [id]: getLocalizedContent(
            isCOC
              ? shareConstants.NoAccessForExternalCOCUserShare
              : shareConstants.NoAccessForExternalUserShare,
          ),
        }
      })
    }
    this.setState((prevState) => ({
      invalidShareeList: {
        ...prevState.invalidShareeList,
        ...invalidShareeList,
      },
    }))
  }

  captureMailId = (evt) => {
    const { shareWithUserMailId, lastEnterKeyPressedTime } = this.state
    if (
      evt.key === 'Enter' ||
      (typeof evt.key === 'undefined' && shareWithUserMailId.trim() !== '')
    ) {
      const inputMailId = evt.target.value
      if (evt.key === 'Enter') {
        if (inputMailId.trim() === '') {
          this.setState({ lastEnterKeyPressedTime: Date.now() })
          this.validateMailIdListBeforeAddingToFinalList()
        } else {
          this.validateAndUpdateMailIdList(evt)
        }
      }
      if (Date.now() - lastEnterKeyPressedTime <= 250) {
        this.validateMailIdListBeforeAddingToFinalList()
      } else {
        this.validateAndUpdateMailIdList(evt)
      }
    } else if (
      typeof evt.key === 'undefined' &&
      shareWithUserMailId.trim() === ''
    ) {
      this.removeErrorMessage()
    }
  }
  validateMailIdListBeforeAddingToFinalList = () => {
    const { invalidShareeList } = this.state
    if (Object.keys(invalidShareeList).length > 0) {
      this.setState({
        shareWithUserMailId: '',
        statusMsg: {
          msg: getLocalizedContent(shareConstants.ValidateEmailIdAlert),
          status: 'error',
          emailError: false,
        },
      })
    } else {
      this.addNewSharee()
    }
  }

  validateAndUpdateMailIdList = (evt) => {
    const { appliedPermissionDefault } = this.state
    const { user } = this.props
    const existingUser = JSON.parse(this.sharedItem)

    const inputMailId = evt.target.value
    const mailIdList = inputMailId.split(';').filter((item) => item)

    /* Get valid and invalid mail id list */
    const [validMailIds, invalidMailIds] = _.partition(mailIdList, (id) => {
      return validateEmailId(id)
    })
    /* Separate self id in exist */
    const [selfIdList, validMailIdList] = _.partition(validMailIds, (id) => {
      return this.checkForMailId(id, user.username, user.email)
    })
    /* Get corp and adhoc user list */
    const [adhocMailIdList, corpMailIdList] = _.partition(
      validMailIdList,
      (id) => {
        return this.isShareeAdhoc(id)
      },
    )
    const [existingCorpMailIdList, _newCorpMailIdList] = _.partition(
      corpMailIdList,
      (id) => {
        return Object.keys(existingUser).includes(id)
      },
    )
    const [existingAdhocMailIdList, _newAdhocMailIdList] = _.partition(
      adhocMailIdList,
      (id) => {
        return Object.keys(existingUser).includes(id)
      },
    )

    this.updateInvalidMailIdDetails(
      invalidMailIds,
      selfIdList,
      existingCorpMailIdList,
      existingAdhocMailIdList,
      adhocMailIdList,
    )

    let properNewMailIdList = {}
    mailIdList.map((id) => {
      properNewMailIdList = {
        ...properNewMailIdList,
        [id]: {
          sharedWith: id,
          ...appliedPermissionDefault,
        },
      }
    })

    this.setState((prevState) => ({
      shareWithUserMailId: '',
      statusMsg: {
        msg: '',
        status: 'success',
        emailError: false,
      },
      shareWithUserList: {
        ...prevState.shareWithUserList,
        ...properNewMailIdList,
      },
    }))
  }

  isContentValid = (content) => {
    const localizedErrorId = validateCustomMessage(content)
    const errorMsg =
      localizedErrorId === '' ? '' : getLocalizedContent(localizedErrorId)
    if (errorMsg !== '') {
      this.setState({ statusMsg: { msg: errorMsg, status: 'error' } })
      this.textArea.current.focus()
      return false
    }
    return true
  }

  handleContentChange = (evt) => {
    const content = evt.target.value
    this.setState({
      messageToShare: content,
      statusMsg: { msg: '', status: 'success' },
    })
  }

  togglePermission = (
    evt,
    showPermission,
    changePermissionForUserOfType = '',
    showPermissionFor = '',
  ) => {
    if (
      shareConstants.IsDifferentPermissionForShareeAllowed ||
      changePermissionForUserOfType === ''
    ) {
      const topPosParent = evt.target.offsetParent.offsetTop
      const scrollTop = this.shareeListContainer.current.scrollTop
      let top
      if (event.target.classList.value.includes('add_user_permission')) {
        top = 35
      } else {
        top = topPosParent - scrollTop + 20
      }
      const left = 'auto'
      const right = -35

      this.setState({
        showPermission,
        showPermissionFor,
        changePermissionForUserOfType,
        permissionBoxPosition: [top, right, left],
      })
    }
  }

  checkPermissionsSet = (permission) => {
    let permissionToRender = ''
    Object.keys(shareConstants.FilePermissionsName).map((per) => {
      if (permission === shareConstants.FilePermissionsName[per]) {
        permissionToRender = shareConstants.FilePermissionToServer[per]
      }
    })
    return permissionToRender
  }

  permissionForFileVault = (permission) => {
    let permissionToSend = ''
    Object.keys(shareConstants.FilePermissionToServer).map((per) => {
      if (permission === shareConstants.FilePermissionToServer[per]) {
        permissionToSend = shareConstants.FilePermissionsName[per]
      }
    })
    return permissionToSend
  }

  checkPermissionToRender = (permission) => {
    return this.permissionForFileVault(permission)
  }

  separateShareFeature = () => {
    const { currentShareeList, finalShareeList, unshareUserList } = this.state
    if (
      finalShareeList.length === 0 &&
      Object.keys(currentShareeList).length === unshareUserList.length
    ) {
      this.unShareFolder()
    }
    this.updateShareeList()
    this.setState({
      shareInProgress: true,
      statusMsg: { msg: '', status: 'success', emailError: false },
      shareWithUserMailId: '',
    })
  }

  calculateSenderEmailId = (shareeList, user) => {
    let sharerEmail = {}
    if (_.has(shareeList, 'enableEmailMask') && shareeList.enableEmailMask) {
      sharerEmail = {
        emailAddress: shareConstants.EmailIdToMaskSenderAddress,
        senderName: shareConstants.NameToMaskSenderName,
      }
    } else {
      sharerEmail = {
        emailAddress: user.email,
        senderName: user.displayname,
      }
    }
    return sharerEmail
  }

  updateShareeList = async () => {
    const { itemToShare, user } = this.props
    const {
      finalShareeList,
      currentShareeList,
      unshareUserList,
      newShareeList,
      messageToShare,
    } = this.state
    const newShareeListForResponse = _.intersection(
      Object.keys(newShareeList),
      finalShareeList,
    )
    let shareeList = []

    /* Add new user list to the request object */
    shareeList = this.addOrUpdateUserToShareeList(
      shareeList,
      newShareeListForResponse,
      'new',
    )

    /* Remove user selected to unshare */
    const removeUnshareUserFromList = _.omit(currentShareeList, unshareUserList)

    /* Update sharee to request object */
    shareeList = this.addOrUpdateUserToShareeList(
      shareeList,
      Object.keys(removeUnshareUserFromList),
      '',
    )

    if (shareeList.length > 0) {
      const params = {
        shares: shareeList,
        sharerEmail: this.calculateSenderEmailId(shareeList[0], user),
        useSharerEmailToNotify: messageToShare !== '',
        notificationContent: messageToShare,
      }

      const updateShareeResponse = await fetchOrUpdateShareeDetails(
        'PUT',
        itemToShare.path,
        params,
      )

      if (updateShareeResponse.status === 200) {
        this.updateShareeSuccessResposne(
          newShareeListForResponse,
          unshareUserList,
          itemToShare,
        )
      } else {
        this.constructErrorMessage(updateShareeResponse, itemToShare, 'share')
      }
      this.setState({ shareInProgress: false })
    }
  }
  updateShareeSuccessResposne = (
    newShareeListForResponse,
    unshareUserList,
    itemToShare,
  ) => {
    this.updateFileListAfterSharing(
      'update',
      newShareeListForResponse,
      unshareUserList,
    )
    this.setState({
      statusMsg: {
        msg: this.constructStatusMessage(itemToShare),
        status: 'success',
        emailError: false,
      },
    })
    this.props.updateFileOrFolderSharedStatus()
    this.updateShareDetails(false)
  }

  constructStatusMessage = (itemToShare) => {
    const { currentShareeList, finalShareeList } = this.state
    if (Object.keys(currentShareeList).length > 0) {
      return getLocalizedContent(
        isFile(itemToShare.fileType)
          ? shareConstants.UpdateFileShareSuccess
          : shareConstants.UpdateFolderShareSuccess,
      )
    }
    if (
      finalShareeList.length > 0 &&
      Object.keys(currentShareeList).length === 0
    ) {
      return getLocalizedContent(
        isFile(itemToShare.fileType)
          ? shareConstants.ShareFileSuccess
          : shareConstants.ShareFolderSuccess,
      )
    }
    return ''
  }

  addOrUpdateUserToShareeList = (shareeList, shareelistToUpdate, type) => {
    const { newShareeList, currentShareeList } = this.state
    let addOrUpdateUserList = []
    shareelistToUpdate.map((id) => {
      if (newShareeList[id] || currentShareeList[id]) {
        addOrUpdateUserList.push(
          type === 'new' ? newShareeList[id] : currentShareeList[id],
        )
      }
    })
    return _.concat(shareeList, addOrUpdateUserList)
  }

  unShareFolder = async () => {
    const { unshareUserList } = this.state
    const { itemToShare } = this.props

    const deleteShareeResponse = await fetchOrUpdateShareeDetails(
      'DELETE',
      itemToShare.path,
      '',
    )
    if (deleteShareeResponse.status === 200) {
      this.updateFileListAfterSharing('unshare', [], unshareUserList)
      this.setState({
        statusMsg: {
          msg: getLocalizedContent(
            isFile(itemToShare.fileType)
              ? shareConstants.UnShareFileSuccess
              : shareConstants.UnShareFolderSuccess,
          ),
          status: 'success',
          emailError: false,
        },
      })
      this.updateShareDetails(true)
    } else {
      this.constructErrorMessage(deleteShareeResponse, itemToShare, 'unshare')
    }
    this.setState({ shareInProgress: false })
  }

  updateFileListAfterSharing = (
    shareType,
    newShareeListForResponse = [],
    unshareUserList = [],
  ) => {
    const { files, itemToShare, fileList } = this.props
    let shareNotificationStatus = _.has(itemToShare, 'shareNotificationStatus')
      ? itemToShare.shareNotificationStatus
      : {}
    newShareeListForResponse.map((sharee) => {
      shareNotificationStatus[sharee] = { IN_PROGRESS: '0' }
    })
    unshareUserList.map((sharee) => {
      delete shareNotificationStatus[sharee]
    })
    const fileListAfterSharing = fileList.results.map((file) =>
      file.path === itemToShare.path
        ? {
            ...file,
            isShared: shareType !== 'unshare',
            shareNotificationStatus,
          }
        : file,
    )
    this.props.actions.setFileListFromResponse({
      total: fileListAfterSharing.length,
      results: fileListAfterSharing,
    })

    const filesListAfterSharing = files.results.map((file) =>
      file.path === itemToShare.path
        ? {
            ...file,
            isShared: shareType !== 'unshare',
            shareNotificationStatus,
          }
        : file,
    )
    this.props.actions.setFileDetails({
      total: filesListAfterSharing.length,
      results: filesListAfterSharing,
    })
  }

  shareUser = () => {
    const { messageToShare } = this.state

    const isContentValid = this.isContentValid(messageToShare)

    if (this.isSharingAllowed() && isContentValid) {
      this.separateShareFeature()
    }
  }

  renderPermissionBox = (userId) => {
    const {
      appliedPermissionDefault,
      newShareeList,
      currentShareeList,
      changePermissionForUserOfType,
      permissionBoxPosition,
    } = this.state
    const { itemToShare } = this.props
    const permissionOptions =
      itemToShare.fileType === 'folder'
        ? shareConstants.SharePermissionsFolder
        : shareConstants.SharePermissionsFiles
    const userPermission =
      changePermissionForUserOfType === 'shared'
        ? currentShareeList[userId]
        : newShareeList[userId]
    const appliedPermission =
      userId === '' ? appliedPermissionDefault : userPermission
    return (
      <div
        ref={this.setRef}
        className="share__permission-option-box"
        style={{
          top: `${permissionBoxPosition[0]}px`,
          right: `${permissionBoxPosition[1]}px`,
          left:
            permissionBoxPosition[2] === 'auto'
              ? permissionBoxPosition[2]
              : `${permissionBoxPosition[2]}px`,
        }}
      >
        {this.renderSharePermissions(
          permissionOptions,
          userId,
          appliedPermission,
        )}
        {this.renderAdditionalPermissions(
          permissionOptions,
          userId,
          appliedPermission,
        )}
      </div>
    )
  }

  renderSharePermissions = (permissionOptions, userId, appliedPermission) => {
    return (
      <div className="share__permission-option-content">
        <ul>
          {permissionOptions.options.length > 0 &&
            permissionOptions.options.map((item, index) => {
              return (
                <li key={`option_${index}`}>
                  <div
                    className={`share__permission-list ${
                      this.checkPermissionToRender(
                        appliedPermission.permission,
                      ) === item
                        ? 'share__permission-list-active'
                        : ''
                    }`}
                    onClick={(evt) =>
                      this.changePermission(evt, 'permission', item, userId)
                    }
                  >
                    <span
                      className={`${
                        this.checkPermissionToRender(
                          appliedPermission.permission,
                        ) === item
                          ? 'ppvx_icon ppvx_icon--size_sm ppvx_icon-check share__permission-list-icon-active'
                          : 'share__permission-list-icon'
                      }`}
                    />
                    <label className="share__permission-label">
                      {this.renderLocalizedLabelForPermission(
                        item,
                        'permission',
                      )}
                    </label>
                  </div>
                </li>
              )
            })}
        </ul>
      </div>
    )
  }

  renderLocalizedLabelForPermission = (permission, type) => {
    let localizedKey = ''
    if (type === 'notification') {
      _.forEach(shareConstants.Notifications, function (value, key) {
        if (value === permission) {
          localizedKey = key
        }
      })
    }
    if (type === 'permission') {
      _.forEach(shareConstants.FilePermissionsName, function (value, key) {
        if (value === permission) {
          localizedKey = key
        }
      })
    }
    return (
      <Message id={shareConstants.localizeIdForPermissions[localizedKey]} />
    )
  }

  checkEmailMaskPermission = (option) => {
    const { user } = this.props
    if (option !== 'enableEmailMask') {
      return true
    }
    return (
      option === 'enableEmailMask' && isUserHasAccess(user, 'Share').hasAccess
    )
  }

  renderAdditionalPermissions = (
    permissionOptions,
    userId,
    appliedPermission,
  ) => {
    return (
      <div className="share__additional-permission-content">
        <ul className="share__additional-permission-list">
          {Object.keys(permissionOptions.notification).length > 0 &&
            Object.keys(permissionOptions.notification).map((item, index) => {
              return (
                this.checkEmailMaskPermission(item) && (
                  <li key={`notification_${index}`}>
                    <div className="share__permission-list">
                      <input
                        id={`notification_${item}`}
                        type="checkbox"
                        value={item}
                        name="notification"
                        onClick={(evt) =>
                          this.changePermission(
                            evt,
                            'notification',
                            item,
                            userId,
                          )
                        }
                        defaultChecked={appliedPermission[item]}
                      />
                      <label
                        className="share__permission-label"
                        htmlFor={`notification_${item}`}
                      >
                        {this.renderLocalizedLabelForPermission(
                          permissionOptions.notification[item],
                          'notification',
                        )}
                      </label>
                    </div>
                  </li>
                )
              )
            })}
        </ul>
      </div>
    )
  }

  renderUserList = (type) => {
    const {
      currentShareeList,
      newShareeList,
      searchNewShareeUserList,
      searchCurrentShareeUserList,
      searchValue,
    } = this.state
    let userList = {}
    if (type === 'shared' && searchValue !== '') {
      userList = searchCurrentShareeUserList
    } else if (type === 'shared') {
      userList = currentShareeList
    }
    if (type === 'new' && searchValue !== '') {
      userList = searchNewShareeUserList
    } else if (type === 'new') {
      userList = newShareeList
    }

    return (
      <div
        className={`${
          type === 'shared'
            ? 'share__existing-user-container'
            : 'share__new-user-container'
        }`}
      >
        {this.renderUserListData(userList, type, searchValue)}
      </div>
    )
  }

  checkLine = (user, finalShareeList, unshareUserList, type) => {
    if (type === 'new') {
      return !finalShareeList.includes(user)
    }
    return unshareUserList.includes(user)
  }

  renderUserListData = (userList, type) => {
    const { itemToShare } = this.props
    return (
      <ul
        className={`share__user-list-box ${
          Object.keys(userList).length > 0 ? '' : 'flexCenter'
        }`}
      >
        {Object.keys(userList).length > 0
          ? Object.keys(userList).map((item, index) => {
              return (
                <li
                  style={{ display: 'flex' }}
                  className={`share__user-list ${
                    type === 'new' ? 'share__user-bold' : ''
                  }`}
                  key={`user_${index}`}
                  data-email={constructUserNameToDisplay(
                    userList[item].sharedWith,
                  )}
                >
                  <div className="share__user-list-individual">
                    {this.renderShareeName(userList, item)}
                    {itemToShare.fileType === 'file'
                      ? this.renderUserActionForFile(
                          type,
                          userList[item].sharedWith,
                        )
                      : this.renderSharePermissionActionForFolder(
                          userList,
                          item,
                          type,
                        )}
                  </div>
                </li>
              )
            })
          : ''}
      </ul>
    )
  }

  renderShareeName = (userList, item) => {
    const { unshareUserList } = this.state
    return (
      <div className="share__user-box">
        <div
          className={`${
            unshareUserList.includes(userList[item].sharedWith)
              ? 'share__user-disabled'
              : ''
          } share__user-id`}
        >
          {constructUserNameToDisplay(userList[item].sharedWith)}
        </div>
      </div>
    )
  }

  renderSharePermissionActionForFolder = (userList, item, type) => {
    const { unshareUserList, finalShareeList } = this.state
    return (
      <div className="share__user-actions">
        {unshareUserList.includes(userList[item].sharedWith)
          ? this.renderUndoLabel()
          : this.renderPermissionButton(
              type,
              this.checkPermissionToRender(userList[item].permission),
              '',
              userList[item].sharedWith,
              this.checkLine(
                userList[item].sharedWith,
                finalShareeList,
                unshareUserList,
                type,
              ),
            )}
        {this.renderUserActionForFolder(userList[item].sharedWith, type)}
      </div>
    )
  }

  renderUndoLabel = () => {
    return (
      <div className={`flexAlignCenter share__user-disabled`}>
        <span className="share__action--label">
          <Message id="share.undo" />
        </span>
      </div>
    )
  }

  renderUserActionForFolder = (userId, type) => {
    const { unshareUserList } = this.state
    return unshareUserList.includes(userId) ? (
      <span
        className="ppvx_icon ppvx_icon--size_sm ppvx_icon-share share__user-disabled rotate-text pointer highlightOnHover share__action--close-icon"
        onClick={() => this.unshareUser(userId, type)}
      />
    ) : (
      <span
        className="ppvx_icon ppvx_icon--size_md ppvx_icon-clear pointer highlightOnHover share__action--close-icon"
        onClick={() => this.unshareUser(userId, type)}
      />
    )
  }

  renderUserActionForFile = (type, userId) => {
    return type === 'new' ? (
      <div className="share__user-actions">
        <span
          className="ppvx_icon ppvx_icon--size_md ppvx_icon-clear pointer"
          onClick={() => this.unshareUser(userId, type)}
        />
      </div>
    ) : (
      this.renderUnShareAction(userId, type)
    )
  }

  renderUnShareAction = (userId, type) => {
    const { unshareUserList } = this.state
    return unshareUserList.includes(userId) ? (
      <div className={`flexAlignCenter share__user-disabled`}>
        <span className="share__action--label">
          <Message id="share.undo" />
        </span>{' '}
        <span
          className="ppvx_icon ppvx_icon--size_sm ppvx_icon-share rotate-text pointer highlightOnHover"
          onClick={() => this.unshareUser(userId, type, true)}
        />
      </div>
    ) : (
      <div
        className={`${
          unshareUserList.includes(userId) ? 'share__user-bold' : ''
        } flexAlignCenter`}
      >
        <span className="share__action--label">
          <Message id="share.stop.sharing" />
        </span>{' '}
        <span
          className="ppvx_icon ppvx_icon--size_md ppvx_icon-clear pointer highlightOnHover"
          onClick={() => this.unshareUser(userId, type, true)}
        />
      </div>
    )
  }

  onMouseOver = (e) => {
    const rect = e.target.getBoundingClientRect()
    if (e.target.children[0]) {
      e.target.children[0].style.top = `${rect.top + 10}px`
      e.target.children[0].style.left = `${rect.left + 10}px`
    }
  }

  renderAddUser = () => {
    return (
      <div className="share__user-add-search">
        <div className="share__user-add-content">
          <div className="share__user-add-labe">
            <Message id="share.share.with.label" />
          </div>
          <div className="share__user-container">
            {this.renderShareWithUserList()}
            {this.renderAddUserInputBox()}
          </div>
          {this.renderSharePermissionBox()}
          <div className="share__apply-permission">
            <div className="tooltip" onMouseOver={(e) => this.onMouseOver(e)}>
              <span
                className="ppvx_icon ppvx_icon--size_lg ppvx_icon-add addIcon"
                onClick={() => this.validateMailIdListBeforeAddingToFinalList()}
              />
              <span className="tooltiptext shareTooltip">
                <Message id="share.add" />
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderSharePermissionBox = () => {
    const {
      appliedPermissionDefault,
      showPermission,
      showPermissionFor,
    } = this.state
    return (
      <div className="share__user-permission-content permission_ref add_user_permission">
        {this.renderPermissionButton(
          '',
          this.checkPermissionToRender(appliedPermissionDefault.permission),
          'add_user_permission',
        )}
        {showPermission && this.renderPermissionBox(showPermissionFor)}
      </div>
    )
  }

  renderPermissionButton = (
    changePermissionForUserOfType,
    label,
    renderPermissionFor,
    sharedWith = '',
    unshare = false,
  ) => {
    return (
      <div
        className={`share__user-permission-box permission_ref ${renderPermissionFor} 
        ${
          changePermissionForUserOfType === '' ||
          shareConstants.IsDifferentPermissionForShareeAllowed
            ? 'pointer'
            : ''
        }`}
        onClick={(e) =>
          this.togglePermission(
            e,
            true,
            changePermissionForUserOfType,
            sharedWith,
          )
        }
      >
        <div
          className={`permission_ref ${renderPermissionFor} share__permission-text`}
        >
          {unshare ? (
            <Message id="share.unshare.button" />
          ) : (
            this.renderLocalizedLabelForPermission(label, 'permission')
          )}
        </div>
        {(changePermissionForUserOfType === '' ||
          shareConstants.IsDifferentPermissionForShareeAllowed) && (
          <div
            className={`share__arrow-down permission_ref ${renderPermissionFor}`}
          />
        )}
      </div>
    )
  }

  renderShareWithUserList = () => {
    const { shareWithUserList, invalidShareeList } = this.state
    const invalidMailIdList = Object.keys(invalidShareeList)
    return (
      <div className="share__add-user-container">
        {Object.keys(shareWithUserList).length > 0 &&
          Object.keys(shareWithUserList).map((item, index) => {
            return (
              <div
                className={`share__userlist-add-container ${
                  invalidMailIdList.includes(item) ? 'sharee__error-id' : ''
                }`}
                key={`add_user_${index}`}
              >
                <div className="share__userlist-add-inner-wrapper">
                  <div
                    className="share__userlist-add-content"
                    onClick={() => this.editEmailId(item)}
                  >
                    <div className="share__userlist-new">
                      <div className="tooltip share__user">
                        {item}
                        {invalidMailIdList.includes(item) && (
                          <span
                            className="tooltiptext share__error-email"
                            style={{ color: 'red' }}
                          >
                            {invalidShareeList[item]}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <button
                    className="share__user-clear"
                    onClick={() => this.removeUser(item)}
                  >
                    <span
                      className={`ppvx_icon ppvx_icon--size_sm ppvx_icon-clear ${
                        invalidMailIdList.includes(item)
                          ? 'sharee__error-icon'
                          : ''
                      }`}
                    />
                  </button>
                </div>
              </div>
            )
          })}
      </div>
    )
  }

  renderAddUserInputBox = () => {
    const { statusMsg, shareWithUserMailId } = this.state
    return (
      <div className="share__user-add-input">
        <InputBox
          name="mail_box"
          ref={this.textInput}
          id="mail_box"
          value={shareWithUserMailId}
          label="Email id"
          className={`input-box input-box__search share__add-user-input-box ${
            statusMsg.emailError ? 'share__alert-input-box' : ''
          }`}
          isLabelHidden={true}
          placeholder="share.email.input.placeholder"
          onChangeText={(e) => this.onChangeMailId(e)}
          onKeyPressText={(e) => this.captureMailId(e)}
          onBlurText={(e) => this.captureMailId(e)}
          maxLength={{}}
          autoFocus={false}
          style={{}}
        />
      </div>
    )
  }

  renderShareAction = () => {
    const { finalShareeList, unshareUserList } = this.state
    const checkButtonVisibility =
      finalShareeList.length > 0 || unshareUserList.length > 0
    return (
      <div className="share__action-container">
        <div className="share__action">
          <button
            className="ppvx_btn ppvx_btn--secondary ppvx_btn--size_md flexCenter"
            onClick={() => this.props.setShareBoxVisibility(false, {})}
          >
            <span className="uploadButton">
              <Message id="buttons.cancel" />
            </span>
          </button>
        </div>
        <div className="share__action">
          <button
            className={`ppvx_btn ppvx_btn--size_md flexCenter ${
              checkButtonVisibility ? '' : 'disable__button'
            }`}
            disabled={!checkButtonVisibility}
            onClick={() => this.shareUser()}
          >
            <span className="uploadButton">
              <Message id="buttons.applyChanges" />
            </span>
          </button>
        </div>
      </div>
    )
  }

  renderShareeList = (newShareeList, type) => {
    return (
      <div
        className={`${
          type === 'shared' ? 'share__existing-user' : 'share__new-user'
        }`}
      >
        {this.renderUserList(type)}
      </div>
    )
  }

  renderShareUser = () => {
    const {
      newShareeList,
      currentShareeList,
      searchValue,
      searchCurrentShareeUserList,
      searchNewShareeUserList,
      shareInProgress,
    } = this.state

    const { itemToShare } = this.props

    const currentUserList = Object.keys(currentShareeList).length
    const newUserList = Object.keys(newShareeList).length

    return (
      <div
        ref={this.shareeListContainer}
        className={`share__user-list-content ${
          currentUserList === 0 && newUserList === 0
            ? 'share__no-user-added'
            : ''
        }`}
      >
        {currentUserList > 0 && this.renderShareeList(newShareeList, 'shared')}
        {newUserList > 0 && this.renderShareeList(newShareeList, 'new')}
        {currentUserList === 0 && newUserList === 0 && !shareInProgress && (
          <div className="share__user-no-data-msg">
            <Message id={`share.${itemToShare.fileType}.no.sharer.info`} />
          </div>
        )}
        {searchValue !== '' &&
          Object.keys(searchCurrentShareeUserList).length === 0 &&
          Object.keys(searchNewShareeUserList).length === 0 && (
            <div className="share__user-no-data-msg">
              <Message id="share.no.results" />
            </div>
          )}
      </div>
    )
  }

  renderCloseIcon = () => {
    return (
      <div className="ppvx_modal-header__close">
        <button
          className="ppvx_modal-header__close-btn"
          data-action-close-modal="true"
          id="hide-my-overpanel"
          aria-label="close lightbox"
          onClick={() => this.props.setShareBoxVisibility(false, {})}
        />
      </div>
    )
  }

  renderSearchUser = () => {
    const { searchValue } = this.state
    return (
      <div className="share__user-search-container">
        <InputBox
          name="search_user"
          id="search_user"
          value={searchValue}
          className="input-box input-box__search share__add-user-input-box"
          label="Search user"
          isLabelHidden={true}
          placeholder="share.search.user"
          onChangeText={(e) => this.searchUser(e)}
          onKeyPressText={(e) => this.searchUser(e)}
          onBlurText={(e) => this.searchUser(e)}
          maxLength={200}
          autoFocus={false}
          style={{}}
        />
      </div>
    )
  }

  renderSharePermissionRequestForm = () => {
    this.props.handleRequestAccessClick()
    return
  }

  renderFormattedMessage = (statusMsg) => {
    const isUploadPermissionBlocked = statusMsg?.msg?.generalMessage?.includes(
      'Upload permission is blocked by compliance restrictions',
    )

    return (
      <div>
        <div>{statusMsg?.msg?.generalMessage}</div>
        <ul style={{ listStyleType: 'auto', paddingLeft: '28px' }}>
          {statusMsg?.msg?.userList.map((list, index) => {
            return <li key={index}>{list}</li>
          })}
        </ul>
        {!isUploadPermissionBlocked && (
          <div className="dFlexAlignCenter flexWrap">
            {/* eslint-disable-next-line i18n-scan/no-inline-concatenation */}
            Please submit &nbsp;
            <a
              className="ppvx_link flexAlignCenter pointer"
              onClick={() => this.renderSharePermissionRequestForm()}
            >
              Share permission request
            </a>
            &nbsp; and try again after approval.
          </div>
        )}
      </div>
    )
  }

  renderstatusMsg = (statusMsg) => {
    return (
      <div
        className={`ppvx_alert ppvx_alert--type_${statusMsg.status} share__alert-box`}
        role="alert"
      >
        {statusMsg?.msg?.generalMessage && statusMsg?.msg?.userList
          ? this.renderFormattedMessage(statusMsg)
          : statusMsg.msg}
      </div>
    )
  }

  renderShareHeader = () => {
    const { itemToShare } = this.props
    return (
      <header className="ppvx_modal-header ppvx_modal-header--no-logo">
        <div className="ppvx_modal-header__action">
          <div className="share__header">
            <div className="share__folder-icon">
              {itemToShare.fileType === 'folder' ? (
                <FolderClose />
              ) : (
                <span className="ppvx_icon ppvx_icon--size_lg list__file-type-icon list__item-icon ppvx_icon-invoice " />
              )}
            </div>
            <div className="share__folder-label">
              <div className="tooltip">
                {itemToShare.fileName.length > 30
                  ? `${itemToShare.fileName.substring(0, 30)}...`
                  : itemToShare.fileName}
                {itemToShare.fileName.length > 30 && (
                  <span className="tooltiptext share__folder-name-tooltip">
                    {itemToShare.fileName}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        {this.renderSearchUser()}
        {this.renderCloseIcon()}
      </header>
    )
  }

  renderLoading = () => {
    return (
      <div className="shareInProgress">
        <p className="ppvx_loading-spinner" role="alert">
          <span className="ppvx_loading-spinner__screenreader" />
        </p>
      </div>
    )
  }

  renderContentBox = () => {
    const { messageToShare } = this.state
    return (
      <div className="share__user-content-container">
        <div className="share__user-content-label">
          <Message id="share.message.label" />
        </div>
        <TextBox
          ref={this.textArea}
          name="share_message"
          id="share_message"
          className="share__user-content-box text-area"
          placeholder="share.message.input.placeholder"
          maxCharacters={500}
          value={messageToShare}
          onChangeText={(e) => this.handleContentChange(e)}
          onBlurText={(e) => this.isContentValid(e.target.value)}
        />
      </div>
    )
  }

  render() {
    const { showShare, user } = this.props
    const {
      isFetchShareInfoInProgress,
      shareInProgress,
      statusMsg,
    } = this.state

    return (
      <div
        className="ppvx_modal-backdrop"
        id="myOverpanel3"
        role="dialog"
        aria-hidden={showShare ? 'false' : 'true'}
        data-ppvx_modal-background-close="true"
      >
        <article className="ppvx_modal" tabIndex="-1">
          {this.renderShareHeader()}
          {statusMsg.msg !== '' && (
            <div className="errorMsg_box">
              {this.renderstatusMsg(statusMsg)}
            </div>
          )}
          <section className="ppvx_modal__contents share__modal-content">
            {this.renderAddUser()}
            {isUserHasAccess(user, 'Content').hasAccess &&
              this.renderContentBox()}
            <div className="share__user-box-content">
              {!isFetchShareInfoInProgress && this.renderShareUser()}
            </div>
            {this.renderShareAction()}
          </section>
          {(isFetchShareInfoInProgress || shareInProgress) &&
            this.renderLoading()}
        </article>
      </div>
    )
  }
}
export default ShareNew
